export const QR_SIZE = 134;
export const LOGO_HEIGHT = 40;
export const FONT_SIZE = 'xs';
